(() => {
  const SELECTORS = {
    root: "[data-eo-pdp]",
    price: "[data-eo-price]",
    compare: "[data-eo-compare]",
    save: "[data-eo-save]",
  };

  class EdenOmPdp {
    constructor(root) {
      if (root.dataset.eoInitialized === "true") return;
      root.dataset.eoInitialized = "true";

      this.root = root;
      this.form = document.getElementById(root.dataset.eoFormId);
      this.variantInput = this.form?.querySelector('input[name="id"]');

      const productDataElement = root.querySelector("[data-eo-product-json]");
      const data = productDataElement ? JSON.parse(productDataElement.textContent) : {};
      this.variants = data.variants || [];
      this.moneyFormat = data.money_format || "${{amount}}";
      this.currentVariant = this.variants.find((variant) => String(variant.id) === this.variantInput?.value)
        || this.variants[0]
        || null;

      this.bind();
      if (this.currentVariant) this.updateVariant(this.currentVariant, null, []);
    }

    bind() {
      this.form?.addEventListener("variant:init", (event) => this.onNativeVariant(event));
      this.form?.addEventListener("variant:change", (event) => this.onNativeVariant(event));
    }

    onNativeVariant(event) {
      const detail = event.detail || {};
      if (!detail.variant) return;
      this.updateVariant(detail.variant, detail.product || null, detail.additionalProducts || []);
    }

    updateVariant(variant, product, additionalProducts) {
      this.currentVariant = variant;

      const price = this.formatMoney(variant.price);
      const priceElement = this.root.querySelector(SELECTORS.price);
      const compare = this.root.querySelector(SELECTORS.compare);
      const save = this.root.querySelector(SELECTORS.save);
      if (priceElement) priceElement.textContent = price;

      if (compare && save && variant.compare_at_price && variant.compare_at_price > variant.price) {
        compare.textContent = this.formatMoney(variant.compare_at_price);
        save.textContent = `Save ${this.formatMoney(variant.compare_at_price - variant.price)}`;
        compare.hidden = false;
        save.hidden = false;
      } else {
           if (compare) compare.hidden = true;
      if (save) save.hidden = true;
    }

    this.updateVariantImages(variant);
  }

  updateVariantImages(variant) {
    const selectedColor = String(variant.option1 || '').trim().toLowerCase();
    const expectedPrefix = selectedColor ? `#color_${selectedColor} /` : '';
    const galleryImages = expectedPrefix
      ? Array.from(document.querySelectorAll('.product-gallery__media-list img')).filter((img) => {
          const alt = String(img.getAttribute('alt') || '').trim().toLowerCase();
          return alt.startsWith(expectedPrefix);
        })
      : [];

    document.querySelectorAll('[data-eo-variant-image]').forEach((img) => {
      const rankValue = img.closest('[data-eo-variant-image-rank]')?.dataset.eoVariantImageRank || '1';
      const rank = Math.max(Number.parseInt(rankValue, 10), 1);
      const source = galleryImages[rank - 1] || galleryImages[0];

      if (source) {
        img.src = source.currentSrc || source.src;
        if (source.srcset) img.srcset = source.srcset;
        else img.removeAttribute('srcset');

        const sourceAlt = String(source.getAttribute('alt') || '').replace(/^#color_[^/]+\/\s*/i, '');
        if (sourceAlt) img.alt = sourceAlt;
        return;
      }

      const image = variant.featured_image;
      if (!image || !image.src) return;
      const imageUrl = new URL(image.src, window.location.origin);
      imageUrl.searchParams.set('width', '1800');
      img.src = imageUrl.toString();
      img.removeAttribute('srcset');
    });
  }

    formatMoney(cents) {
      const format = this.moneyFormat || "${{amount}}";
      const token = format.match(/\{\{\s*(\w+)\s*\}\}/)?.[1] || "amount";
      const amount = Number(cents || 0) / 100;
      const value = token.includes("no_decimals")
        ? Math.round(amount).toLocaleString()
        : amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return format.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/\.00(?=\D*$)/, "");
    }
  }

  const init = (scope = document) => scope.querySelectorAll(SELECTORS.root).forEach((root) => new EdenOmPdp(root));
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => init());
  else init();
  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
